"use strict";

var _objectSpread = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _objectWithoutProperties = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;
const _excluded = ["docsPath"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCallError = void 0;
const contract_js_1 = require("../../errors/contract.js");
const node_js_1 = require("../../errors/node.js");
const getNodeError_js_1 = require("./getNodeError.js");
function getCallError(err, _ref) {
  let {
      docsPath
    } = _ref,
    args = _objectWithoutProperties(_ref, _excluded);
  const cause = (() => {
    const cause = (0, getNodeError_js_1.getNodeError)(err, args);
    if (cause instanceof node_js_1.UnknownNodeError) return err;
    return cause;
  })();
  return new contract_js_1.CallExecutionError(cause, _objectSpread({
    docsPath
  }, args));
}
exports.getCallError = getCallError;
//# sourceMappingURL=getCallError.js.map